import { render, staticRenderFns } from "./PiProductListDialog.vue?vue&type=template&id=3b3af012&scoped=true"
import script from "./PiProductListDialog.vue?vue&type=script&lang=ts"
export * from "./PiProductListDialog.vue?vue&type=script&lang=ts"
import style0 from "./PiProductListDialog.vue?vue&type=style&index=0&id=3b3af012&prod&scoped=true&lang=scss"
import style1 from "./PiProductListDialog.vue?vue&type=style&index=1&id=3b3af012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3af012",
  null
  
)

export default component.exports